import styled from 'styled-components'
import { ModalBase } from '../../../../components/v2Components'

export const Modal = styled(ModalBase)`
  overflow-y: clip;
`
